module.exports = __webpack_public_path__ + "img/Box.7f2cea1b.png";